export class CodeEditorDialog {
  Titel: string;
  Language: string;
  Code: string;
}
